import { Component, Input, OnInit } from '@angular/core';
import { BoxInfoRouterService } from './box-info-router.service';
import { Util, StatusEntrega, StatusRoteiroPedidos, TipoEntregas, ConfiguracaoInfoCliente } from '../shared/Util';
import { environment } from '../../environments/environment';
import { GraphicService } from '../shared/graphic.service';
import { IconService } from '../shared/icon.service';

import { BoxListTruckService } from '../box-list-truck/box-list-truck.service';
import { PopupDetalhesPedidoService } from '../popup-detalhes-pedido/popup-detalhes-pedido.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationService } from '../shared/notification.service';
import { NgIf, NgFor, NgClass, DatePipe } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { BoxInfoRouterAddessComponent } from '../box-info-router-addess/box-info-router-addess.component';
import { DetalheEntregaColetaComponent } from '../detalhe-entrega-coleta/detalhe-entrega-coleta.component';
import { TextoLinkComponent } from '../shared/componentes/texto-link/texto-link.component';
import { PopupDownloadTodosComprovantesComponent } from '../popup-download-todos-comprovantes/popup-download-todos-comprovantes.component';
import { FilterPipe } from '../../pipes/pesquisa/pesquisa.pipe';

declare var jquery: any;
declare var $: any;
declare let jsPDF;
declare var bootstrap: any;

@Component({
    selector: 'box-info-router',
    templateUrl: './box-info-router.component.html',
    styleUrls: ['./box-info-router.component.css'],
    standalone: true,
    imports: [NgIf, NgbTooltip, FormsModule, NgFor, NgClass, BoxInfoRouterAddessComponent, DetalheEntregaColetaComponent, TextoLinkComponent, PopupDownloadTodosComprovantesComponent, DatePipe, FilterPipe]
})
export class BoxInfoRouterComponent implements OnInit {
  mostraComprovanteApp = false;
  @Input() dados = null;
  proximoCliente = null
  roteiroFinalizado = false;
  iconRotated = false;
  listaRoteiroCliente: any[] = [];
  exibirBotaoDownloadComprovantes: boolean = false;
  tempoTotalEntrega: number = 0;
  versaoApp: string;
  iconesENomesIntervalos = [
    {tipo: 'REFEICAO', urlIcon: 'assets/img/lunch-router.svg', nome: 'Pausa para refeição'},
    {tipo: 'PERNOITE', urlIcon: 'assets/img/hotel-router.svg', nome: 'Pausa para pernoite'},
    {tipo: 'EXCEPCIONAL', urlIcon: 'assets/img/watch-router.svg',  nome: 'Pausa excepcional'}
  ];
  pesquisaCliente: any;
  mostrarClientesVisitados = true;
  selectedIndex: number | null = null;
  stars = [1, 2, 3, 4, 5];
  mostrarBtnCompartilharRast: boolean = false;
  configNomeClienteExibicao = ConfiguracaoInfoCliente.RazaoSocial;
  enumConfiguracaoInfoCliente = ConfiguracaoInfoCliente;

  constructor(
    public boxInfoRouterService: BoxInfoRouterService,
    private boxListTruckService: BoxListTruckService,
    private util: Util,
    private graphicService: GraphicService,
    private iconService: IconService,
    private detalhesPedidosServices: PopupDetalhesPedidoService,
    private notificationService: NotificationService,
    public sanitizer:DomSanitizer
  ) {

  }

  ngOnInit() {
    this.getInfoRouter();
    this.versaoApp = this.boxListTruckService.listTruckService.VersaoApp;
    let infoRota = JSON.parse(this.dados.InfoRota)
    if(infoRota.ConfigNomeClienteExibicao){
      this.configNomeClienteExibicao = infoRota.ConfigNomeClienteExibicao
    }

    this.mostraComprovanteApp = infoRota.ConfigRecebimentoApp == '0' ? false : true;
    this.mostrarBtnCompartilharRast = this.compararVersao('7.0.11', infoRota.VersaoRetaguarda ?? null)
  }

  carregarLista() {
    for (let item of this.listaRoteiroCliente) {
      let pedido = item.pedidos.find(p => p.IdPedidoConfirmacaoEntrega != null);
      if (pedido) {
          this.exibirBotaoDownloadComprovantes = true;
          item.PrevisaoSaida = new Date(this.boxListTruckService.listTruckService.PrevisaoSaida);
          item.DesabilitaVisualizacao = this.dataExpirada(item.PrevisaoSaida);
      }
    }
  }

  dataExpirada(data: Date): boolean {
    const hoje = new Date();
    const umAnoAtras = new Date();
    umAnoAtras.setFullYear(hoje.getFullYear() - 1);

    return data < umAnoAtras;
  }

  async getInfoRouter()
  {
    await this.graphicService.limparPontosMapa();
    let codigoClienteAnterior: any;
    let contador: number = 1;
    this.listaRoteiroCliente = [];
    this.graphicService.posicaoCliente = {};
    this.tempoTotalEntrega = 0;
    this.graphicService.duracaoTotalEntrega = "00:00";

    await this.boxInfoRouterService.getInfoIntervalos();
    await this.boxInfoRouterService.getInfoRouter();
    this.preencheCustoDescargaCli()

    let infoRota: any = JSON.parse(this.dados.InfoRota) ?? false;
    let consideraEndPed = infoRota.ConsideraEndPed? true: false;

    for(let i = 0; i < this.boxInfoRouterService.infoRouter.length; i++)
    {
        const itemAtual = this.boxInfoRouterService.infoRouter[i];
        let jaProcessado = false;
        if (consideraEndPed) {
          jaProcessado = this.listaRoteiroCliente.some((item: any) =>
            item.CodigoCliente == itemAtual.CodigoCliente &&
            item.Latitude == itemAtual.Latitude &&
            item.Longitude == itemAtual.Longitude
          );
        } else {
          jaProcessado = codigoClienteAnterior == itemAtual.CodigoCliente;
        }

        if(!jaProcessado)
        {
          let valorTotalPedido = 0;
          let pesoTotalPedido = 0;

          this.graphicService.posicaoCliente[this.boxInfoRouterService.infoRouter[i].CodigoCliente] = contador;

          this.boxInfoRouterService.infoRouter[i].pedidos = [];

          let temOcorrencia = this.boxInfoRouterService.infoRouter[i].problemaReportado;
          let regiaoRisco = this.boxInfoRouterService.infoRouter[i].RegiaoRisco
          let codigoAcao = this.boxInfoRouterService.infoRouter[i].CodigoAcao;
          let IdRoteiroPedidoSituacao = this.boxInfoRouterService.infoRouter[i].IdRoteiroPedidoSituacao;

          // Verifica os pedidos do cliente
          let filtroPedido = [];
          if(consideraEndPed){
            filtroPedido = this.boxInfoRouterService.infoRouter.filter((pedido: any) => {
              if (itemAtual.IdCliente && pedido.IdCliente) {
                return pedido.IdCliente == itemAtual.IdCliente;
              }
              if (itemAtual.NuPedidosConsideraEndPed) {
                try {
                  let lista = typeof itemAtual.NuPedidosConsideraEndPed === 'string'
                    ? JSON.parse(itemAtual.NuPedidosConsideraEndPed)
                    : itemAtual.NuPedidosConsideraEndPed;
                  if (Array.isArray(lista)) {
                    return lista.some((item: any) => {
                      let nuPed = item.nuPed ?? item.NuPed;
                      let cdEmp = item.cdEmp ?? item.CdEmp;
                      let nuPedMatch = nuPed != null && nuPed == pedido.NumeroPedido;
                      let cdEmpMatch = (cdEmp && pedido.cdEmp && cdEmp != 0 && pedido.cdEmp != 0)
                        ? cdEmp == pedido.cdEmp
                        : true;
                      return nuPedMatch && cdEmpMatch;
                    });
                  }
                } catch (e) {
                  console.log("CATCH________getInfoRouter");
                  console.log(e);
                }
              }
              return pedido.CodigoCliente == itemAtual.CodigoCliente &&
                pedido.Latitude == itemAtual.Latitude &&
                pedido.Longitude == itemAtual.Longitude;
            });
          }else{
            filtroPedido = this.boxInfoRouterService.infoRouter.filter(x => x.CodigoCliente == this.boxInfoRouterService.infoRouter[i].CodigoCliente);
          }

          for(let j = 0; j < filtroPedido.length; j++)
          {
            let pedido: any = {};

            pedido.DataPedido = filtroPedido[j].DataPedido;
            pedido.FormaPagamento = filtroPedido[j].FormaPagamento;
            pedido.FormaPagamentoEfetuada = filtroPedido[j].FormaPagamentoEfetuada;
            pedido.Nf = filtroPedido[j].Nf;
            pedido.NumeroPedido = filtroPedido[j].NumeroPedido;
            pedido.Peso = filtroPedido[j].Peso;
            pedido.QtdeVolumes = filtroPedido[j].QtdeVolumes;
            pedido.ValorPedido = filtroPedido[j].ValorPedido;
            pedido.IdRoteiroPedidoSituacao = filtroPedido[j].IdRoteiroPedidoSituacao;
            pedido.EntregaRealizada = filtroPedido[j].EntregaRealizada
            pedido.detalhePedido = filtroPedido[j].Tipo == TipoEntregas.Entrega ? filtroPedido[j].ResumoNFeJSON : filtroPedido[j].InfoPed
            pedido.chaveAcesso = filtroPedido[j].chaveAcesso
            pedido.RegiaoRisco = filtroPedido[j].RegiaoRisco
            pedido.Tipo = filtroPedido[j].Tipo
            pedido.IdPedidoConfirmacaoEntrega = filtroPedido[j].IdPedidoConfirmacaoEntrega
            pedido.IdRoteiroPedido = filtroPedido[j].IdRoteiroPedido
            pedido.NotaAvaliacao = filtroPedido[j].NotaAvaliacao

            valorTotalPedido += filtroPedido[j].ValorPedido;
            pesoTotalPedido += filtroPedido[j].Peso;

            const pedidos = this.boxInfoRouterService.infoRouter[i].pedidos;

            const pedidoDuplicado = pedidos.some(p =>
              p.Nf === pedido.Nf && p.NumeroPedido === pedido.NumeroPedido
            );

            if (!pedidoDuplicado) {
              pedidos.push(pedido);
            }
            
          }

          let statusEntrega = await this.statusEntrega(this.boxInfoRouterService.infoRouter[i].pedidos);
          let parcial = [
            StatusEntrega.Parcial,
            StatusEntrega.ParcialComNaoIniciada,
            StatusEntrega.ParcialComVoltoDepois,
            StatusEntrega.ParcialNoCliente,
            StatusEntrega.FinalizadoExcecao].indexOf(statusEntrega) != -1;

          //Verificar se o ícone do cliente é parcial ou não

          let unSanitizaded =true
          let temColeta = this.boxInfoRouterService.infoRouter[i].pedidos.some((pedido) => pedido.Tipo == TipoEntregas.Coleta)
          let temImportacaoXML = this.boxInfoRouterService.infoRouter[i].pedidos.some((pedido) => pedido.Tipo == TipoEntregas.XmlEntrega)
          let urlSujo = this.iconService.iconeCliente(contador, codigoAcao, temOcorrencia, parcial, IdRoteiroPedidoSituacao, statusEntrega, regiaoRisco, unSanitizaded, temColeta, temImportacaoXML);
          let urlLimpo = this.iconService.iconeCliente(contador, codigoAcao, temOcorrencia, parcial, IdRoteiroPedidoSituacao, statusEntrega, regiaoRisco, null, temColeta, temImportacaoXML);

          this.boxInfoRouterService.infoRouter[i].urlImagemRoteiroBoxLateral =urlLimpo
          this.boxInfoRouterService.infoRouter[i].urlImagemRoteiro = urlSujo

          this.boxInfoRouterService.infoRouter[i].valorTotalPedido = valorTotalPedido;
          this.boxInfoRouterService.infoRouter[i].pesoTotalPedido = pesoTotalPedido;
          this.boxInfoRouterService.infoRouter[i].dataInicioEntrega = this.boxInfoRouterService.infoRouter[i].dataInicioEntrega != null ? this.util.converteData(this.boxInfoRouterService.infoRouter[i].dataInicioEntrega) : null;
          this.boxInfoRouterService.infoRouter[i].dataFinalEntrega = this.boxInfoRouterService.infoRouter[i].dataFinalEntrega != null ? this.util.converteData(this.boxInfoRouterService.infoRouter[i].dataFinalEntrega) : null;
          this.boxInfoRouterService.infoRouter[i].tempoEntrega = this.boxInfoRouterService.infoRouter[i].tempoEntrega != null ? this.boxInfoRouterService.infoRouter[i].tempoEntrega.toString().split('T')[1].replace('.000Z', '') : '-'

          let entregaParcial = this.boxInfoRouterService.infoRouter.some(
            (pedido) =>
            pedido.CodigoCliente == this.boxInfoRouterService.infoRouter[i].CodigoCliente
            && pedido.IdRoteiroPedidoSituacao == StatusRoteiroPedidos.EntregaParcial )


          this.boxInfoRouterService.infoRouter[i].IdRoteiroPedidoSituacao =
              entregaParcial? StatusRoteiroPedidos.EntregaParcial:
              this.boxInfoRouterService.infoRouter[i].IdRoteiroPedidoSituacao !== null ?
              this.boxInfoRouterService.infoRouter[i].IdRoteiroPedidoSituacao : 1;


          this.boxInfoRouterService.infoRouter[i].statusEntrega = statusEntrega;

          this.tempoTotalEntrega += parseInt(this.boxInfoRouterService.infoRouter[i].tempoEntregaValor);

          if(this.boxInfoRouterService.infoRouter[i].dataInicioEntrega == null && this.boxInfoRouterService.infoRouter[i].dataFinalEntrega != null)
          {
            this.boxInfoRouterService.infoRouter[i].dataInicioEntrega = this.boxInfoRouterService.infoRouter[i].dataFinalEntrega;
          }

          this.boxInfoRouterService.infoRouter[i].InfoRota = this.dados.InfoRota

          this.listaRoteiroCliente.push(this.boxInfoRouterService.infoRouter[i]);
          contador++;
        }

        codigoClienteAnterior = this.boxInfoRouterService.infoRouter[i].CodigoCliente;
    }

    //Adiciona intervalo na listaRoteiroCliente
    let controle = 0
      if(this.boxInfoRouterService.infoIntervalos){
        this.boxInfoRouterService.infoIntervalos.forEach(element => {
          let intervalo = {
            minutos: element.Minutos.toString(),
            nome: this.iconesENomesIntervalos.find( (x) => x.tipo === element.Tipo).nome,
            urlIcon: this.iconesENomesIntervalos.find( (x) => x.tipo === element.Tipo).urlIcon,
          }

          let indice = this.listaRoteiroCliente.findIndex((x) => {
            if(x.pedidos){
              return x.pedidos[0].NumeroPedido == element.NumeroPedidoAnteced
            }
          });

          this.listaRoteiroCliente.splice(indice + controle ,0, intervalo);
          },
          controle++
        );
      }

    if(this.tempoTotalEntrega > 0)
    {
      let dtAux = new Date(null);
      dtAux.setSeconds(this.tempoTotalEntrega);

      let tempo = dtAux.toISOString().substr(11, 8);

      this.graphicService.duracaoTotalEntrega = tempo;
    }

    let pontoInicial = {};
    await this.graphicService.visualizarRoteiroCliente(this.boxInfoRouterService.infoRouter);
    this.atualizaProximoCliente();

    if(this.graphicService.numeroClienteFoco){
      this.graphicService.retornarPontoCliente(this.graphicService.numeroClienteFoco)
    }

    if(this.graphicService.coordenadaCenter != null && this.graphicService.coordenadaCenter.latitude != undefined ){
      this.graphicService.retornarPontoCoordenada()
    }
    this.carregarLista()
  }

  showHideAddress(index)
  {
    this.selectedIndex = this.selectedIndex === index ? null : index;
    this.listaRoteiroCliente[index].show = !this.listaRoteiroCliente[index].show;
  }

  AbrirTabelaPedidos(e)
  {
    if ($(e.currentTarget).hasClass('open')) {
        $(e.currentTarget).removeClass('open');
      $(e.currentTarget).parent().find('.pedidos-detalhes').slideUp(200);
      } else {
        $(e.currentTarget).addClass('open');
      $(e.currentTarget).parent().find('.pedidos-detalhes').slideDown(200);
      }

  }

  exibirClienteMapa(codigoCliente)
  {
    this.graphicService.retornarPontoCliente(codigoCliente);
  }

  async statusEntrega(pedidos){
    let listPed = pedidos.filter(pedido => pedido.IdRoteiroPedidoSituacao == StatusEntrega.RecebimentoRecusado || pedido.IdRoteiroPedidoSituacao == StatusEntrega.Finalizado).map(pedido => pedido.IdRoteiroPedidoSituacao);
    if(listPed.length > 0 && listPed.length == pedidos.length){
      if(listPed.indexOf(StatusEntrega.Finalizado) == -1 || listPed.indexOf(StatusEntrega.RecebimentoRecusado) == -1){
        return listPed[0] == StatusEntrega.Finalizado ? 6 : 5;
      }else{
        return 7;
      }
    }else if(listPed.indexOf(StatusEntrega.RecebimentoRecusado) != -1 || listPed.indexOf(StatusEntrega.Finalizado) != -1){
      let listPedTotal = pedidos.filter(pedido => pedido.IdRoteiroPedidoSituacao == StatusEntrega.ChegouCliente || pedido.IdRoteiroPedidoSituacao == StatusEntrega.VoltoDepois || pedido.IdRoteiroPedidoSituacao == StatusEntrega.IniciouEntrega).map(pedido => pedido.IdRoteiroPedidoSituacao);
      //Entrega que já chegou no cliente.
      if(listPedTotal.indexOf(StatusEntrega.IniciouEntrega) != -1){
        return 11;
      }else if(listPedTotal.indexOf(StatusEntrega.ChegouCliente) != -1){
        return 9;
      }else if(listPedTotal.indexOf(StatusEntrega.VoltoDepois) != -1){
        return 10;
      }else{
        return 8;
      }

    }else{
      return 0;
    }
  }


  atualizaDetalhesPedido(lista){
    this.detalhesPedidosServices.atualizaDetalhesPedidos(lista)
  }

  atualizaProximoCliente(){
    this.roteiroFinalizado = this.dados.IdRoteiroSituacao == 5;
    if(this.dados.ProximoCliente ){
      this.proximoCliente = this.listaRoteiroCliente.find((cliente) => cliente.CodigoCliente == this.dados.ProximoCliente);

      if(this.proximoCliente == undefined){
        this.proximoCliente = this.listaRoteiroCliente.find((cliente) => cliente.IdRoteiroPedido == this.dados.ProximoCliente
        );
      }
    }
  }

  descomprimiArquivos(){
    this.listaRoteiroCliente.forEach((cliente) => {
      if(cliente.Arquivo){
        cliente.Arquivo = Util.decompress(cliente.Arquivo);
      }
    })
  }

  toggleModalDownloadComprovantes() {
    this.boxInfoRouterService.exibirModalComprovante = !this.boxInfoRouterService.exibirModalComprovante
  }

  async getComprovante(item){ 
    this.boxInfoRouterService.dadosComprovante = null;
    let idPedidoConfirmacaoEntrega = null
    let contemConfirmacaoEntrega = item.pedidos.some((pedido) => pedido.IdPedidoConfirmacaoEntrega != null);
    if(contemConfirmacaoEntrega){
      idPedidoConfirmacaoEntrega = item.pedidos.find((pedido) => pedido.IdPedidoConfirmacaoEntrega != null).IdPedidoConfirmacaoEntrega
    }

    const idRoteiroPedido = item.pedidos.find((pedido) => pedido.IdRoteiroPedidoSituacao == StatusRoteiroPedidos.EntregaFinalizada).IdRoteiroPedido ?? 0;

    if(idPedidoConfirmacaoEntrega){
      let resultado = await this.boxInfoRouterService.getComprovante(idPedidoConfirmacaoEntrega)
      item.NomeRecebedor = resultado.NomeRecebedor;
      item.DocumentoRecebedor = resultado.DocumentoRecebedor;
      item.IdRoteiro = resultado.IdRoteiro

      if(resultado.Arquivo){
          item.Arquivo = Util.decompress(resultado.Arquivo);
          this.boxInfoRouterService.dadosComprovante = item;
      }

      await this.boxInfoRouterService.getAlteracaoComprovante(this.boxInfoRouterService.dadosComprovante.IdRoteiro,  idRoteiroPedido);
    }
    else{
      this.notificationService.showInformativo('Comprovante não localizado');
      setTimeout(() => {
        document.getElementById('btnCloseModalDadoRecebedor').click();
      }, 1);
    }

  }


  async abreImgLocalEntrega(cliente){
      let arquivo = await this.boxInfoRouterService.getComprovanteLocalEntrega(cliente.IdCliente, cliente.NumeroRoteiro)
      cliente.arquivo = Util.decompress(arquivo);
      this.boxInfoRouterService.clienteLocalEntrega = cliente;
  }

  preencheCustoDescargaCli(){
      let infoRota = JSON.parse(this.dados.InfoRota)
      let listaCustoDescarga = infoRota?.InfoRoteirizacao?.custoDescargaClientes ?? []
      if (this.boxInfoRouterService.infoRouter.length) {
        this.boxInfoRouterService.infoRouter.forEach((cliente: any) => {
            const custoDescarga = listaCustoDescarga.find((cli: any) => cli.codCliente === cliente.CodigoCliente);
            cliente.custoDescarga = custoDescarga ? custoDescarga.custoDescarga : 0;
        });
     }
  }

  copiarAcomponhamento(chaveAcesso){
     navigator.clipboard.writeText(`https://rastreiotgt.net/?chaveAcesso=${chaveAcesso}`).then(() => {
      this.notificationService.showInformativo('Texto copiado para a área de transferência')
    }).catch((error) => {
      console.error('Erro ao copiar para a área de transferência: ', error);
    });
  }

  compararVersao(versaoLiberada, versaoRetaguarda){
    if(versaoRetaguarda == null) return false;
    const verRetarguarda = versaoRetaguarda.split('.').map(Number);
    const verLiberada = versaoLiberada.split('.').map(Number);
    const maiorOuIgual = 
    verRetarguarda[0] > verLiberada[0] ? true :
    verRetarguarda[0] < verLiberada[0] ? false :
    verRetarguarda[1] > verLiberada[1] ? true :
    verRetarguarda[1] < verLiberada[1] ? false :
    verRetarguarda[2] >= verLiberada[2];
    return maiorOuIgual;
  };

  abrirComprovanteModal(){
    const modalElement = document.getElementById('popupID-dados-recebedor');
    const modalInstance = new bootstrap.Modal(modalElement);
    modalInstance.show();
  }
}
